import Iconify from "src/components/iconify";
import { PATH_ADMIN } from "src/routes/paths";

const ICONS = {
  dashboard: <Iconify icon="eva:pie-chart-2-fill" />,
  clients: <Iconify icon="humbleicons:users" />,
  finance: <Iconify icon="solar:wallet-money-outline" />,
  usage: <Iconify icon="solar:chart-2-outline" />,
  aiCost: <Iconify icon="solar:cpu-bolt-outline" />,
  partners: <Iconify icon="solar:users-group-two-rounded-outline" />,
  plans: <Iconify icon="solar:document-text-outline" />,
};

const navConfig = [
  {
    subheader: "",
    items: [
      { title: "Dashboard", path: PATH_ADMIN.dashboard, icon: ICONS.dashboard },
      { title: "Financeiro", path: PATH_ADMIN.finance, icon: ICONS.finance },
      { title: "Uso", path: PATH_ADMIN.usage, icon: ICONS.usage },
      { title: "Custo de IA", path: PATH_ADMIN.aiCost, icon: ICONS.aiCost },
      { title: "Clientes", path: PATH_ADMIN.clients, icon: ICONS.clients },
      { title: "Parceiros", path: PATH_ADMIN.partners, icon: ICONS.partners },
      { title: "Planos", path: PATH_ADMIN.plans, icon: ICONS.plans },
    ],
  },
];

export default navConfig;
